import React, { useEffect, useState } from "react";
import { Layout, Menu, Button, Badge } from "antd";
// import dashboradLogo from '../../assets/dashboradLogo.png'
import dashboradLogo from "../../assets/logo.png";
import {
  MdOutlineSubscriptions,
  MdOutlineDashboardCustomize,
} from "react-icons/md";
import { LiaSitemapSolid } from "react-icons/lia";
import { LiaBusinessTimeSolid } from "react-icons/lia";
import Avatar from "@mui/material/Avatar";
import NotificationModel from "../Layout/NotificationModel";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  BarChartOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  CloseCircleOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { FaWallet, FaBell } from "react-icons/fa";
import { CiPower } from "react-icons/ci";
import { CgProfile } from "react-icons/cg";
import { Link, Outlet, useLocation } from "react-router-dom";
import GetLeadsModal from "../Modals/GetLeadsModal";
import { useNavigate } from "react-router-dom"; // Import the useHistory hook
import { connect } from "react-redux";
import { setUser } from "../../store/action/common/authAction";
import ManualLeadsModal from "../Modals/ManualLeadsModal";
import { getWalletAmount } from "../../store/action/business/TxnAction";
import { GrTableAdd } from "react-icons/gr";
import {
  setLeadMode,
  resetLeadMode,
} from "../../store/action/common/leadModeAction";
import { Grid } from "antd";
import UpdateUserModal from "../UpdateUserPopup";
import axiosNew from "../../store/api/axiosNew";

const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;

const SiderDemo = (props) => {
  const companyName = localStorage.getItem("companyName");
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [leadsModalVisible, setLeadsModalVisible] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const isAdmin = props.user?.role === "admin";
  const isBusiness = props.user?.role === "business";

  const isRetail = props.leadMode === "retail";

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const mobileSizes = {
    headerHeight: 64,
    buttonHeight: 30,
    fontSize: 12,
    iconSize: 14,
    paddingX: 8,
    gap: 6,
  };
  const leadButtonStyle = {
    height: isMobile ? mobileSizes.buttonHeight : 40,
    fontSize: isMobile ? mobileSizes.fontSize : 14,
    padding: isMobile ? `0 ${mobileSizes.paddingX}px` : "0 16px",
  };
  const walletButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? mobileSizes.gap : 10,
    height: isMobile ? mobileSizes.buttonHeight : 40,
    fontSize: isMobile ? mobileSizes.fontSize : 15,
    padding: isMobile ? `0 ${mobileSizes.paddingX}px` : "10px 20px",
    backgroundColor: "#F7F7F7",
    color: "#5F5F5F",
    border: "1px solid #ddd",
    borderRadius: "6px",
  };

  const profileButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? mobileSizes.gap : 10,
    height: isMobile ? 40 : 50,
    padding: isMobile ? "6px 10px" : "8px 16px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    cursor: "pointer",
  };

  const leadModePaths = {
    admin: {
      dashboard: {
        retail: "/admin/retail-admin-dashboard",
        subscription: "/admin",
      },
      transactionHistory: {
        retail: "/retail-transaction-history",
        subscription: "/transaction-history",
      },
    },
    business: {
      dashboard: {
        retail: "/user-dashboard",
        subscription: "/",
      },
      myBusinessLeads: {
        // retail: "/retail-my-leads",
        retail: "/my-leads-retail",
        subscription: "/my-bussiness-leads",
      },
      transactionHistory: {
        retail: "/retail-transaction-history",
        subscription: "/transaction-history",
      },
    },
  };

  const businessRouteMap = {
    "/": leadModePaths.business.dashboard,
    "/user-dashboard": leadModePaths.business.dashboard,
    "/my-bussiness-leads": leadModePaths.business.myBusinessLeads,
    "/my-leads-retail": leadModePaths.business.myBusinessLeads,
    "/transaction-history": leadModePaths.business.transactionHistory,
    "/retail-transaction-history": leadModePaths.business.transactionHistory,
  };

  useEffect(() => {
    if (!props.user) return;

    const role = props.user?.role;
    const mode = props.leadMode || "subscription";
    const currentPath = location.pathname;

    if (role === "business") {
      const targetConfig = businessRouteMap[currentPath];

      // ✅ If route exists for BOTH modes → switch
      if (targetConfig) {
        const targetPath = targetConfig[mode];

        if (currentPath !== targetPath) {
          navigate(targetPath, { replace: true });
        }

        return;
      }

      // ✅ If page is common → DO NOTHING
      // NO dashboard redirect
    }
  }, [props.leadMode, props.user, location.pathname]);

  const switchLeadMode = (mode) => {
    if (mode === props.leadMode) return;

    props.setLeadMode_(mode);

    const role = props.user?.role;
    const currentPath = location.pathname;
  };

  useEffect(() => {
    if (
      props.user?.role === "business" &&
      props.wallet &&
      props.wallet.response &&
      props.wallet.response.walletAmount
    ) {
      setWalletAmount(props.wallet.response.walletAmount);
      localStorage.setItem(
        "myWallet",
        JSON.stringify(props.wallet.response.walletAmount),
      );
    }
  }, [props.wallet]);

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const userId = localStorage.getItem("id");
        const res = await axiosNew.get(`/notification/${userId}/unread`);
        if (res.data.success) {
          setUnreadCount(res.data.count);
        }
      } catch (err) {
        console.error("Error fetching unread count:", err);
      }
    };
    fetchUnreadCount();
    props.getWalletAmount_(null);
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const openModal = () => {
    setModalVisible(true); // Set the modal visibility to true when the button is clicked
  };
  const closeModal = () => {
    setModalVisible(false); // Set the modal visibility to true when the button is clicked
  };

  const openLeadsModal = () => {
    setLeadsModalVisible(true); // Set the modal visibility to true when the button is clicked
  };
  const closeLeadsModal = () => {
    setLeadsModalVisible(false); // Set the modal visibility to true when the button is clicked
  };

  const logout = () => {
    // localStorage.clear();
    // props.setUser_(null);
    // props.clearLoginResponse_();
    // window.location.href = '/login';
    props.resetLeadMode_();
    localStorage.clear(); // Clear localStorage
    props.setUser_(null); // Clear user from Redux
    props.clearLoginResponse_(); // Clear login response from Redux
    navigate("/login"); // Use React Router to navigate to login page
  };

  if (!props.user) {
    return null; // or a loader spinner
  }

  const getButtons = () => {
    if (props.user && props.user?.role === "admin") {
      return (
        <>
          <div style={{ display: "flex", gap: 16 }}>
            <Button
              type={props.leadMode === "subscription" ? "primary" : "default"}
              onClick={() => switchLeadMode("subscription")}
              style={leadButtonStyle}
            >
              {isMobile ? "Sub" : "Subscription Leads"}
            </Button>

            <Button
              type={props.leadMode === "retail" ? "primary" : "default"}
              onClick={() => switchLeadMode("retail")}
              style={leadButtonStyle}
            >
              {isMobile ? "Retail" : "Retail Leads"}
            </Button>
          </div>

          <img
            style={{
              width: "auto",
              height: "25px",
              marginRight: "15px",
              borderRadius: "5px",
              border: "2px solid #ccc",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            }}
            src="https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png"
          />
          {/* <Button
            type="light"
            style={{
              color: "black",
              backgroundColor: "white",
              borderColor: "#1890ff",
            }}
            onClick={openLeadsModal}
          >
            Add Leads
          </Button> */}
        </>
      );
    } else if (props.user && props.user.role === "business") {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 10px",
          }}
        >
          {/* <Button type="primary" style={{ height: "40px", color: "white",marginRight: "16px", background: "linear-gradient(to right, #5767f3, #172851)",borderColor: "transparent",borderRadius: "6px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",fontWeight: "bold", }}
        onClick={openModal}>
        Upgrade Credits
      </Button> */}
          {/* My wallet */}
          <div
            style={{
              display: "flex",
              alignitems: "center",
              gap: isMobile ? 6 : 12,
            }}
          >
            <Button
              type={props.leadMode === "subscription" ? "primary" : "default"}
              onClick={() => {
                if (props.user?.role === "business") {
                  const subscriptionSignup =
                    props.user?.subscriptionSignup ??
                    localStorage.getItem("subscriptionSignup") === "true";
                  if (!subscriptionSignup) {
                    setShowUpdateModal(true);
                  } else {
                    switchLeadMode("subscription");
                  }
                }
              }}
              style={leadButtonStyle}
            >
              {isMobile ? "Sub" : "Subscription Leads"}
            </Button>

            <Button
              type={props.leadMode === "retail" ? "primary" : "default"}
              onClick={() => switchLeadMode("retail")}
              style={leadButtonStyle}
            >
              {isMobile ? "Rtl" : "Retail Leads"}
            </Button>
          </div>
          <Button
            type="light"
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "10px",
              marginLeft: "10px",
              height: isMobile ? 30 : 40,
              padding: isMobile ? "0 8px" : "10px 20px",
              fontSize: isMobile ? 12 : 15,
              gap: "10px",
              border: "1px solid #ddd",
              backgroundColor: "#F7F7F7",
              color: "#5F5F5F",
            }}
            onClick={() => navigate("/transaction-history")}
          >
            <FaWallet size={isMobile ? 14 : 16} />
            {!isMobile && <span>My Credits : {walletAmount}</span>}
            {isMobile && <span>{walletAmount}</span>}
          </Button>

          {/* Bell Icon */}
          {/* <NotificationModel/> */}
          {/* <Button type="light" style={{borderRadius: '50%',width: '40px',height: '40px',padding: '0',display: 'flex',
         alignItems: 'center',justifyContent: 'center',backgroundColor: '#f5f5f5', marginRight:'10px',border: 'none',position: 'relative',}}>
           <FaBell style={{ fontSize: '20px', color: '#5F5F5F' }} />
          <div style={{ position: 'absolute', bottom: '10px', right: '5px',width: '8px',height: '8px',borderRadius: '50%',
                  backgroundColor: '#ff4d4f' }}/>
            </Button> */}
          {/* Business Profile */}
          <Button
            type="default"
            onClick={() => {
              navigate("/my-profile");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: isMobile ? 32 : 46,
              width: isMobile ? 60 : 220,
              padding: isMobile ? 0 : "6px 12px",
              borderRadius: "6px",
              overflow: "hidden",
            }}
          >
            <Avatar size={isMobile ? 6 : 28}>
              {companyName?.charAt(0).toUpperCase()}
            </Avatar>

            {!isMobile && (
              <>
                <div
                  style={{
                    marginLeft: 8,
                    flex: 1,
                    overflow: "hidden",
                    lineHeight: 1.2,
                  }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {companyName}
                  </div>
                  <div style={{ fontSize: 11, color: "#888" }}>
                    Business Panel
                  </div>
                </div>
              </>
            )}
            <MdOutlineKeyboardArrowDown
              size={isMobile ? 10 : 16}
              style={{ marginLeft: "auto", flexShrink: 0 }}
            />
          </Button>
          <Button
            type="light"
            style={{
              position: "relative",
              border: "none",
              background: "transparent",
              padding: 10,
            }}
            onClick={() => navigate("/notification-page")}
          >
            <FaBell size={20} />{" "}
            {unreadCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -4,
                  right: 4,
                  background: "red",
                  color: "white",
                  borderRadius: "50%",
                  fontSize: "10px",
                  minWidth: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {unreadCount}
              </span>
            )}
          </Button>
        </div>
      );
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", width: "100vw" }}>
      <Header
        className="site-layout-background"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          backgroundColor: "#ffff",
          padding: 0,
          padding: isMobile ? "0 8px" : 0,
          height: isMobile ? mobileSizes.headerHeight : 64,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={dashboradLogo}
            style={{
              width: isMobile ? 48 : 70,
              margin: isMobile ? "6px" : "20px",
            }}
            className="logo"
          />
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: toggle,
              style: {
                fontSize: isMobile ? 18 : 22,
                color: "#4D5156",
                marginLeft: isMobile ? 8 : 70,
              },
            },
          )}
        </div>
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            marginRight: "20px",
            color: "white",
          }}
        >
          {getButtons()}
        </div> */}
        <div style={{ flex: 1 }} /> {/* spacer */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginRight: isMobile ? 4 : 20,
            gap: isMobile ? 6 : 12,
            color: "white",
          }}
        >
          {getButtons()}
        </div>
      </Header>
      <UpdateUserModal
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        onSuccess={() => {
          localStorage.setItem("subscriptionSignup", "true");
          setShowUpdateModal(false);
          switchLeadMode("subscription");
        }}
      />
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            position: "fixed",
            top: "64px", // Height of the fixed header
            left: 0,
            bottom: 0,
            zIndex: 1000,
            backgroundColor: "#ffff",
            paddingTop: "20px",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <div style={{ flex: 1, overflowY: "auto" }}>
              <Menu
                style={{ marginTop: "10px" }}
                theme="light"
                mode="inline"
                defaultSelectedKeys={[location.pathname]}
                key={location.pathname}
                items={[
                  {
                    key: "general",
                    type: "group", // Group header
                    label: (
                      <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
                        Menu
                      </p>
                    ),
                  },
                  // {
                  //   key: props.user.role === "admin" ? "/admin" : "/",
                  //   icon: <BarChartOutlined />,
                  //   label: (
                  //     <Link
                  //       to={props.user.role === "admin" ? "/admin" : "/"}
                  //       style={{ textDecoration: "none" }}
                  //     >
                  //       Dashboard
                  //     </Link>
                  //   ),
                  // },
                  {
                    key: leadModePaths[
                      props.user?.role === "admin" ? "admin" : "business"
                    ].dashboard[props.leadMode],
                    icon: <BarChartOutlined />,
                    label: (
                      <Link
                        to={
                          leadModePaths[
                            props.user?.role === "admin" ? "admin" : "business"
                          ].dashboard[props.leadMode]
                        }
                        style={{ textDecoration: "none" }}
                      >
                        {props.user?.role === "admin"
                          ? "Dashboard"
                          : "Buy Leads"}
                      </Link>
                    ),
                  },
                  props.user?.role === "business" && {
                    key: leadModePaths["business"].myBusinessLeads[
                      props.leadMode
                    ],
                    icon: <UsergroupAddOutlined />,
                    label: (
                      <Link
                        to={
                          leadModePaths["business"].myBusinessLeads[
                            props.leadMode
                          ]
                        }
                        style={{ textDecoration: "none" }}
                      >
                        My Leads
                      </Link>
                    ),
                  },

                  props.user &&
                    props.user.role === "admin" && {
                      key: "/retail-disqualified-leads",
                      icon: <UserDeleteOutlined />,
                      label: (
                        <Link
                          to="/admin/retail-disqualified-leads"
                          style={{ textDecoration: "none" }}
                        >
                          Retail Disqualified leads
                        </Link>
                      ),
                    },

                  props.user &&
                    props.user.role === "admin" && {
                      key: "/retail-user-interactions",
                      icon: <UserOutlined />,
                      label: (
                        <Link
                          to="/admin/retail-user-interactions"
                          style={{ textDecoration: "none" }}
                        >
                          Retail User Interaction List
                        </Link>
                      ),
                    },

                  // props.user &&
                  //   props.user.role === "admin" && {
                  //     key: "/add-cart-page",
                  //     icon: <BarChartOutlined />,
                  //     label: (
                  //       <Link
                  //         to="/admin/add-cart-page"
                  //         style={{ textDecoration: "none" }}
                  //       >
                  //         Cart
                  //       </Link>
                  //     ),
                  //   },
                  props.user &&
                    props.user?.role === "admin" && {
                      key: "/my-leads",
                      icon: <UsergroupAddOutlined />,
                      label: (
                        <Link to="/my-leads" style={{ textDecoration: "none" }}>
                          Super Leads
                        </Link>
                      ),
                    },

                  props.user &&
                    props.user?.role === "admin" && {
                      key: "/leadbulkupload",
                      icon: <GrTableAdd />,
                      label: (
                        <Link
                          to="/admin/leadbulkupload"
                          style={{ textDecoration: "none" }}
                        >
                          Lead Bulk Upload
                        </Link>
                      ),
                    },

                  // {
                  //   key: "/transaction-history",
                  //   icon: <DollarOutlined />,
                  //   label: (
                  //     <Link
                  //       to="/transaction-history"
                  //       style={{ textDecoration: "none" }}
                  //     >
                  //       Transaction History
                  //     </Link>
                  //   ),
                  // },
                  {
                    key: leadModePaths[
                      props.user?.role === "admin" ? "admin" : "business"
                    ].transactionHistory[props.leadMode],
                    icon: <DollarOutlined />,
                    label: (
                      <Link
                        to={
                          leadModePaths[
                            props.user?.role === "admin" ? "admin" : "business"
                          ].transactionHistory[props.leadMode]
                        }
                        style={{ textDecoration: "none" }}
                      >
                        Transaction History
                      </Link>
                    ),
                  },

                  props.user?.role === "business" && {
                    key: "general",
                    type: "group", // Group header for another section
                    label: (
                      <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
                        General
                      </p>
                    ),
                  },
                  props.user?.role === "business" && {
                    key: "/setting",
                    icon: <SettingOutlined />,
                    label: (
                      <Link to="/setting" style={{ textDecoration: "none" }}>
                        Settings
                      </Link>
                    ),
                  },
                  props.user?.role === "business" && {
                    key: "/helpdesk",
                    icon: <QuestionCircleOutlined />,
                    label: (
                      <Link to="/helpdesk" style={{ textDecoration: "none" }}>
                        Help Desk
                      </Link>
                    ),
                  },
                  props.user?.role === "business" && {
                    key: "/my-profile",
                    icon: <CgProfile size={15} />,
                    label: (
                      <Link to="/my-profile" style={{ textDecoration: "none" }}>
                        My Profile
                      </Link>
                    ),
                  },

                  props.user &&
                    props.user?.role === "admin" && {
                      key: "/businesses",
                      icon: <LiaBusinessTimeSolid />,
                      label: (
                        <Link
                          to="/admin/businesses"
                          style={{ textDecoration: "none" }}
                        >
                          Businesses
                        </Link>
                      ),
                    },
                  props.user &&
                    props.user?.role === "admin" && {
                      key: "/business-and-lead-mapping",
                      icon: <LiaBusinessTimeSolid />,
                      label: (
                        <Link
                          to="/admin/business-and-lead-mapping"
                          style={{ textDecoration: "none" }}
                        >
                          B & L Map
                        </Link>
                      ),
                    },
                  // props.user && props.user.role === 'admin' && {
                  //   key: '/utm-mapping',
                  //   icon: <LiaSitemapSolid />,
                  //   label: (
                  //     <Link to="/admin/utm-mapping" style={{ textDecoration: 'none' }}>
                  //      UTM Mapping
                  //     </Link>
                  //   ),
                  // },

                  props.user &&
                    props.user?.role === "admin" && {
                      key: "/business-mapping",
                      icon: <MdOutlineDashboardCustomize />,
                      label: (
                        <Link
                          to="/admin/business-mapping"
                          style={{ textDecoration: "none" }}
                        >
                          Customized Plan
                        </Link>
                      ),
                    },
                  props.user &&
                    props.user?.role === "admin" && {
                      key: "/subscription-master",
                      icon: <MdOutlineSubscriptions />,
                      label: (
                        <Link
                          to="/admin/subscription-master"
                          style={{ textDecoration: "none" }}
                        >
                          Subscription master
                        </Link>
                      ),
                    },
                  // props.user && props.user.role === 'admin' && {
                  //   key: '/tickets',
                  //   icon: <ProfileOutlined />,
                  //   label: (
                  //     <Link to="/admin/tickets" style={{ textDecoration: 'none' }}>
                  //       Tickets
                  //     </Link>
                  //   ),
                  // },
                ].filter(Boolean)}
              />
            </div>
            <button
              style={{
                margin: collapsed ? "0 10px 20px 10px" : "0 20px 20px 20px",
                padding: "10px",
                backgroundColor: "#FFF2F3",
                color: "#E72A3D",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={logout}
            >
              <CiPower
                style={{ fontSize: "large", margin: "0px 5px 2px 0px" }}
              />{" "}
              Logout
            </button>
          </div>
        </Sider>
        {isMobile && !collapsed && (
          <div
            onClick={() => setCollapsed(true)}
            style={{
              position: "fixed",
              top: "64px", // header height
              left: 200, // sidebar width
              right: 0,
              bottom: 0,
              zIndex: 999,
              background: "transparent",
            }}
          />
        )}
        <Content
          className="site-layout-background"
          style={{
            marginLeft: collapsed ? "80px" : "200px", // Adjust based on Sider's width
            marginTop: "64px", // Height of the fixed header
            padding: "24px",
            overflowY: "auto",
            height: "calc(100vh - 64px)", // Full height minus header height
          }}
        >
          <Outlet />
        </Content>
      </Layout>
      <GetLeadsModal visible={modalVisible} closeModal={closeModal} />
      <ManualLeadsModal
        visible={leadsModalVisible}
        closeModal={closeLeadsModal}
      />
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.response,
  wallet: state.wallet,
  leadMode: state.leadMode.mode,
});

const mapDispatchToProps = (dispatch) => ({
  getWalletAmount_: () => dispatch(getWalletAmount()),
  setUser_: (data) => {
    dispatch(setUser(data));
  },
  clearLoginResponse_: () => {
    dispatch({ type: "FETCH_LOGIN_CLEAR" });
  },
  setLeadMode_: (mode) => dispatch(setLeadMode(mode)),
  resetLeadMode_: () => dispatch(resetLeadMode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiderDemo);
